var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 300 300",
      "width": "200",
      "height": "200"
    }
  }, [_c('g', {
    attrs: {
      "id": "SVGRepo_bgCarrier",
      "stroke-width": "0"
    }
  }), _c('g', {
    attrs: {
      "id": "SVGRepo_tracerCarrier",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('g', {
    attrs: {
      "id": "SVGRepo_iconCarrier"
    }
  }, [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('circle', {
    staticStyle: {
      "fill": "#32373b"
    },
    attrs: {
      "cx": "148.5",
      "cy": "148.5",
      "r": "148.5"
    }
  })])])])])]), _c('g', [_c('g', [_c('g', [_c('g', [_c('g', [_c('circle', {
    staticStyle: {
      "fill": "#32373b"
    },
    attrs: {
      "cx": "148.5",
      "cy": "148.5",
      "r": "148.5"
    }
  })])])])])])]), _c('path', {
    staticStyle: {
      "fill": "#262c30"
    },
    attrs: {
      "d": "M296.753,140.003L239.24,82.49L57.75,231l63.495,63.495c8.836,1.639,17.944,2.505,27.255,2.505 c82.014,0,148.5-66.486,148.5-148.5C297,145.647,296.911,142.816,296.753,140.003z"
    }
  }), _c('g', [_c('polygon', {
    staticStyle: {
      "fill": "#ffa800"
    },
    attrs: {
      "points": "239.25,231 57.75,231 57.75,82.5 148.5,33 239.25,82.5 "
    }
  })]), _c('g', [_c('polygon', {
    staticStyle: {
      "fill": "#e59405"
    },
    attrs: {
      "points": "239.25,82.5 148.667,33.091 148.667,231 239.25,231 "
    }
  })]), _c('g', [_c('polygon', {
    staticStyle: {
      "fill": "#f0deb4"
    },
    attrs: {
      "points": "219.045,231 77.955,231 77.955,99.062 148.5,60.583 219.045,99.062 "
    }
  })]), _c('g', [_c('polygon', {
    staticStyle: {
      "fill": "#ceb78a"
    },
    attrs: {
      "points": "219.045,99.062 148.667,60.674 148.667,231 219.045,231 "
    }
  })]), _c('g', [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "#d36818"
    },
    attrs: {
      "x": "155.875",
      "y": "181.5",
      "width": "49.5",
      "height": "49.5"
    }
  })]), _c('g', [_c('rect', {
    staticStyle: {
      "fill": "#e67e22"
    },
    attrs: {
      "x": "91.625",
      "y": "181.5",
      "width": "49.5",
      "height": "49.5"
    }
  })])]), _c('g', [_c('rect', {
    staticStyle: {
      "fill": "#c0392b"
    },
    attrs: {
      "x": "123.75",
      "y": "132",
      "width": "49.5",
      "height": "49.5"
    }
  })]), _c('g', [_c('rect', {
    staticStyle: {
      "fill": "#a82720"
    },
    attrs: {
      "x": "148.667",
      "y": "132",
      "width": "24.583",
      "height": "49.5"
    }
  })])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }